import type { Location } from '@/shared/types/location'

type TownCountyCellProps = {
  location: Location
}

export const TownCountyCell = ({ location }: TownCountyCellProps) => {
  const { town, county } = location

  if (!town && !county) {
    return null
  }

  if (!town) {
    return <span>{county}</span>
  }

  if (!county) {
    return <span className="font-bold">{town}</span>
  }

  return (
    <>
      <span className="font-bold block">{town}</span>
      <span>{county}</span>
    </>
  )
}
